import { createTripletGlyphIcon } from '../../../utils/createTripletGlyphIcon';

/** Source: `svg-to-react-generator/source-svgs/outline/{S,M,L}/multiple choice.svg` */
export const MultipleChoiceIcon = createTripletGlyphIcon('MultipleChoiceIcon', {
  s: () => (
    <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M11.0026 5.08044C11.208 4.85722 11.5553 4.84217 11.7789 5.04724C12.0025 5.25263 12.0173 5.60087 11.8121 5.82458L7.40491 10.6254C7.04767 11.0142 6.44198 11.0368 6.05627 10.6761L4.13635 8.88025C3.91486 8.67269 3.90355 8.32461 4.11096 8.10291C4.31854 7.8816 4.66667 7.87016 4.88831 8.07751L6.69592 9.76892L11.0026 5.08044Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M12.9069 1.21033C13.9468 1.21033 14.7904 2.05325 14.7906 3.09314V12.9066C14.7906 13.9468 13.947 14.7904 12.9069 14.7904H3.09241C2.05248 14.7902 1.20959 13.9466 1.20959 12.9066V3.09314C1.20988 2.0534 2.05266 1.21058 3.09241 1.21033H12.9069ZM3.09241 2.30994C2.66017 2.31019 2.30949 2.66092 2.3092 3.09314V12.9066C2.3092 13.3391 2.66 13.6896 3.09241 13.6898H12.9069C13.3395 13.6898 13.6901 13.3392 13.6901 12.9066V3.09314C13.6898 2.66076 13.3393 2.30994 12.9069 2.30994H3.09241Z"
        fill="currentColor"
      />
    </svg>
  ),
  m: () => (
    <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12.4277 5.76221C12.6332 5.53846 12.9813 5.52358 13.2051 5.729C13.4287 5.93444 13.4436 6.28264 13.2383 6.50635L8.28027 11.9067C7.90422 12.3162 7.26542 12.3402 6.85938 11.9604L4.7002 9.94092C4.47846 9.73344 4.46744 9.38539 4.6748 9.16357C4.88232 8.94179 5.23034 8.92971 5.45215 9.13721L7.53711 11.0884L12.4277 5.76221Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.5205 1.43018C15.6525 1.43024 16.5702 2.34796 16.5703 3.47998V14.52C16.5703 15.6521 15.6526 16.5698 14.5205 16.5698H3.47949C2.34741 16.5697 1.42971 15.6521 1.42969 14.52V3.47998C1.42984 2.34798 2.34748 1.43027 3.47949 1.43018H14.5205ZM3.47949 2.52979C2.955 2.52988 2.52945 2.9555 2.5293 3.47998V14.52C2.52932 15.0446 2.95492 15.4701 3.47949 15.4702H14.5205C15.0451 15.4701 15.4707 15.0446 15.4707 14.52V3.47998C15.4706 2.95548 15.045 2.52985 14.5205 2.52979H3.47949Z"
        fill="currentColor"
      />
    </svg>
  ),
  l: () => (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M16.5581 7.67236C16.8382 7.36728 17.3125 7.34647 17.6177 7.62646C17.9226 7.90661 17.9426 8.38097 17.6626 8.68604L14.3574 12.2866L11.0522 15.8872C10.5447 16.4398 9.68343 16.4727 9.13525 15.9604L6.25537 13.2671C5.95298 12.9842 5.93749 12.509 6.22021 12.2065C6.5032 11.9041 6.97828 11.8884 7.28076 12.1714L10.0483 14.7603L16.5581 7.67236Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.3608 1.89014C20.8793 1.8904 22.1106 3.12168 22.1108 4.64014V19.3599C22.1108 20.8785 20.8794 22.1096 19.3608 22.1099H4.63916C3.12049 22.1097 1.88916 20.8786 1.88916 19.3599V4.64014C1.88935 3.1216 3.12061 1.89027 4.63916 1.89014H19.3608ZM4.63916 3.39014C3.94904 3.39027 3.38935 3.95002 3.38916 4.64014V19.3599C3.38916 20.0501 3.94892 20.6097 4.63916 20.6099H19.3608C20.051 20.6096 20.6108 20.0501 20.6108 19.3599V4.64014C20.6106 3.95011 20.0509 3.3904 19.3608 3.39014H4.63916Z"
        fill="currentColor"
      />
    </svg>
  ),
});
